import type { VAxios } from '../define/axios/Axios';

import { MessageList } from '../entities/cc/messages.entities';

/**
 * 消息接口配置
 */
export const createApi = (defHttp: VAxios) => ({
  //#region 文件上传接口
  // 获取临时文件上传地址
  getTempUploadTokenInfo: () => defHttp.get({ url: `/aiad/upload/tmp` }),
  //#endregion

  //#region 消息接口
  // 获取消息
  getMessages: (params) =>
    defHttp.get<MessageList>({ url: `/aiad/messages`, params }, { preventErrorHandle: true }),
  // 读消息
  readMessage: (params) => defHttp.post({ url: '/aiad/messages/read', params }),
  //#endregion
});
